import * as React from "react";
const SvgFiRrPersonDollyEmpty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-person-dolly-empty_svg__a)">
      <path
        fill="#062147"
        d="M1 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m22.975 15.544a1 1 0 0 0-1.2-.749l-7.795 1.804-3.004-13.318a.999.999 0 1 0-1.951.439L11.103 11H8.618l-1.37-2.739A4.07 4.07 0 0 0 3.59 6 3.597 3.597 0 0 0 0 9.604l.053 3.78a3.98 3.98 0 0 0 1.938 3.371l2.524 1.52c.299.179.484.508.484.856V23a1 1 0 1 0 2 0v-3.869a3.01 3.01 0 0 0-1.454-2.57l-2.524-1.519a1.99 1.99 0 0 1-.969-1.686l-.053-3.767c0-.877.713-1.59 1.59-1.59q.21 0 .41.04v4.96a1 1 0 1 0 2 0v-2.764l.829 1.658a1.99 1.99 0 0 0 1.789 1.105h2.936l1.369 6.068a2.5 2.5 0 1 0 3.011 1.863l7.291-1.687c.538-.125.873-.662.749-1.2zM2 19a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-person-dolly-empty_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPersonDollyEmpty;
